//@ts-ignore: Temporary while rewrite of components with dnd
import { DragDropContext } from 'react-dnd-old';
import { HTML5Backend } from 'react-dnd-html5-backend-old';

let context;

function DNDHTMLBackend(DecoratedClass) {
  if (context) {
    return context(DecoratedClass);
  }
  context = DragDropContext(HTML5Backend);
  return context(DecoratedClass);
}

export { DNDHTMLBackend };